/* Be Savage - sticky mobile add-to-cart bar for Dawn product pages */
(function () {
  if (!document.querySelector('product-form, .product-form')) return;

  var realBtn = document.querySelector('.product-form__submit');
  if (!realBtn) return;

  var priceEl = document.querySelector('.price__regular .price-item, .price-item--regular');
  var priceText = priceEl ? priceEl.textContent.trim() : '';

  var bar = document.createElement('div');
  bar.className = 'sv-sticky-atc';
  bar.innerHTML =
    '<span class="sv-s-price">' + priceText + '</span>' +
    '<button type="button">Add to cart</button>';
  document.body.appendChild(bar);

  bar.querySelector('button').addEventListener('click', function () {
    realBtn.click();
  });

  function toggle() {
    var mobile = window.matchMedia('(max-width: 900px)').matches;
    if (!mobile) { bar.classList.remove('sv-visible'); return; }
    var rect = realBtn.getBoundingClientRect();
    var offscreen = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('sv-visible', offscreen);
  }
  window.addEventListener('scroll', toggle, { passive: true });
  window.addEventListener('resize', toggle);
  toggle();
})();